import React from "react"
import { useStaticQuery, graphql, Link as L } from "gatsby"
import Img from "gatsby-image"
import { Link } from "react-scroll"

import "./NavModal.scss"

import Closer from "../../../images/closer.svg"

const NavModal = ({ site, handeler, modalState }) => {
  const navImg = useStaticQuery(graphql`
    query {
      facebookLogo: file(relativePath: { eq: "facebook_logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <div
      className={`nav-modal ${modalState === false ? "hide-nav" : "show-nav"}`}
    >
      <div className="nav-modal-bg"></div>
      <img onClick={handeler} src={Closer} alt="Close" />
      <nav>
        <ul className="navigation-list">
          <li>
            {site === "index" ? (
              <Link
                spy={true}
                smooth={true}
                duration={500}
                activeClass="active"
                to="home"
                className="nav-home"
                onClick={handeler}
              >
                Home
              </Link>
            ) : (
              <L to="/#home" className="nav-home" onClick={handeler}>
                Home
              </L>
            )}
          </li>
          <li>
            {site === "index" ? (
              <Link
                spy={true}
                smooth={true}
                duration={500}
                activeClass="active"
                to="veranstaltungen"
                className="nav-varenstaltungen"
                onClick={handeler}
              >
                Veranstaltungen
              </Link>
            ) : (
              <L
                to="/#veranstaltungen"
                className="nav-varenstaltungen"
                onClick={handeler}
              >
                Veranstaltungen
              </L>
            )}
          </li>
          <li>
            {site === "index" ? (
              <Link
                spy={true}
                smooth={true}
                duration={500}
                activeClass="active"
                to="fahrgeschaefte"
                className="nav-booking"
                onClick={handeler}
              >
                Fahrgeschäfte
              </Link>
            ) : (
              <L
                to="/#fahrgeschaefte"
                className="nav-booking"
                onClick={handeler}
              >
                Fahrgeschäfte
              </L>
            )}
          </li>
          <li>
            {site === "index" ? (
              <Link
                spy={true}
                smooth={true}
                duration={500}
                activeClass="active"
                to="eiswagen"
                className="nav-eissorten"
                onClick={handeler}
              >
                Eiswagen
              </Link>
            ) : (
              <L to="/#eiswagen" className="nav-eissorten" onClick={handeler}>
                Eiswagen
              </L>
            )}
          </li>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={500}
              activeClass="active"
              to="footer"
              className="nav-kontakt"
              onClick={handeler}
            >
              Kontakt
            </Link>
          </li>
          <li>
            <a href="https://www.facebook.com/Eis-Charlie-159432034168973/">
              <Img fluid={navImg.facebookLogo.childImageSharp.fluid} />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default NavModal
